module.exports = __webpack_public_path__ + "img/logo.e1ef111d.png";